import * as DOMPurify from "isomorphic-dompurify";

export function sanitize(text: string, authorizedAttribute = {}): string {
  return DOMPurify.sanitize(text, authorizedAttribute);
}
